import axios from 'axios'
import { Discount } from '../../interfaces'

export const deleteDiscount = (discount: Discount) => {
  return axios.delete('/data/atlaide/' + discount.id)
}
